import { LOCALSTORAGE_PREFIX } from 'config/config.types';

export const DATE_FORMAT = 'DD.MM.YYYY';

export const USER_DATA_LOCAL_STORAGE_KEY = LOCALSTORAGE_PREFIX + 'userData';

export const HEADER_HEIGHT = 68;
export const TOP_MENU_HEIGHT = 60;
export const ONE_LEVEL_TABS_HEIGHT = 44;
export const TWO_LEVEL_TABS_HEIGHT = 88;
